import {putAdviseSessionInCache} from 'hooks/adviseSessions';
import api from 'services/Api';

export async function instantAdviseSessionCreate(
  category,
  duration,
  anonymous,
  discountCode,
  skillId,
  history,
  packagePurchaseId,
) {
  try {
    const {data} = await api.invoke(
      'POST',
      '/core/v1/instantAdviseSessions',
      {
        category,
        duration,
        anonymous,
        discountCode,
        skillId,
        packagePurchaseId,
      },
      {
        api: {
          emitNotification: true,
        },
      },
    );
    return data;
  } catch (error) {
    category === 'PSYCHOLOGY'
      ? sessionStorage.setItem(
          'psychologyInstanceCall',
          `/app/psychologyInstanceCall`,
        )
      : sessionStorage.setItem(
          'medicineInstanceCall',
          `/app/medicineInstanceCall`,
        );
    history.push('/user/login');

    // throw new Error('Unauthorized: Please login to create an instant advise session');
    throw error;
  }
}

// export async function instantAdviseSessionCreate(
//   category,
//   duration,
//   anonymous,
//   discountCode,
//   skillId,
// ) {
//   const {data} = await api.invoke(
//     'POST',
//     '/core/v1/instantAdviseSessions',
//     {
//       category,
//       duration,
//       anonymous,
//       discountCode,
//       skillId,
//     },
//     {
//       api: {
//         emitNotification: true,
//       },
//     },
//   );
//   return data;
// }

export async function instantAdviseSessionAssign() {
  const {data} = await api.invoke(
    'POST',
    '/core/v1/instantAdviseSessions/assign',
  );
  return data;
}

export async function instantAdviseSessionStatus(id) {
  const {data} = await api.invoke(
    'GET',
    `/core/v1/instantAdviseSessions/${id}/status`,
  );
  if (data.status === 'ACCEPTED') {
    putAdviseSessionInCache(data.adviseSession);
  }
  return data;
}

export function instantAdviseSessionCancel(id) {
  return api.invoke(
    'POST',
    `/core/v1/instantAdviseSessions/${id}/cancel`,
    null,
    {
      api: {emitNotification: true},
    },
  );
}

export async function instantAdviseSessionAccept(id) {
  const {data} = await api.invoke(
    'POST',
    `/core/v1/instantAdviseSessions/${id}/accept`,
    null,
    {
      api: {emitNotification: true},
    },
  );
  putAdviseSessionInCache(data.adviseSession);
  return data;
}

export function instantAdviseSessionReject(id) {
  return api.invoke(
    'POST',
    `/core/v1/instantAdviseSessions/${id}/reject`,
    null,
    {
      api: {emitNotification: true},
    },
  );
}
export async function checkDiscountCode(data) {
  const {data: resData} = await api.invoke(
    'POST',
    `/core/v1/instantAdviseSessions/checkDiscountCode`,
    data,
  );
  return resData;
}
